import VerticalPromoLeadForm from '@/components/LeadForm/VerticalPromoLeadForm';
import React from 'react';
import BlueOnWhiteLogo from '@/components/Logo/BlueOnWhiteLogo';
import { useRouter } from 'next/router';

const Page = () => {
  const router = useRouter();
  const uid = router.query.uid;
  const promo = router.query.promo;

  // Convert promo to a string if it's an array
  const promoValue = uid ? uid.toString() : promo ? promo.toString() : '';

  return (
    <div className="bg-gray-100 min-h-screen flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-3xl ">
        <div className="w-48 pb-2 md:mx-0 mx-auto">
          <BlueOnWhiteLogo />
        </div>
        <hr />

        <h1 className="text-2xl font-semibold mb-4 pt-2 pl-2">
          Schedule a consultation with our expert Energy Advisors to discuss
          your needs.
        </h1>
        <VerticalPromoLeadForm prefix="vertical" uid={promoValue} />
      </div>
    </div>
  );
};

export default Page;
